import axios from 'axios';
import { getToken } from '@/utils/storage';

const BASE_DOMAIN = process.env.VUE_APP_BASE_DOMAIN || 'http://localhost:3000';
const API_PREFIX = '';

const axiosInstance = axios.create({
  baseURL: `${BASE_DOMAIN}/${API_PREFIX}/`,
});

export default axiosInstance;

export function setAuthToken(token: string) {
  axiosInstance.defaults.headers.Authorization = `Bearer ${token}`;
}

const token = getToken();

if (token) {
  setAuthToken(token);
}
